module.exports = __webpack_public_path__ + "img/piero.f6653e2.png";